export const headerZIndex = 999999;
export const navZIndex = 9999;
export const pageSearchSortZIndex = 9996;
export const pageFiltersZIndex = 9995;
